import { useMutation } from "@tanstack/react-query";
import NotificationTab from "./notification-tab";
import orbitService from "../../services/orbit-service";
import { useDispatch, useSelector } from "react-redux";
import { getAuthDetails } from "../../../../feature/auth-slice";
import {useNotifyApi } from "../../../../utils/notifyHook";
import { useNavigate } from "react-router";
import { useState } from "react";
import { orbitParamValue } from "../../../../utils/helper";
import { useSearchParams } from "react-router-dom";
import { setNotification, setNotificationData } from "../../../../feature/notification-slice";

const NotificationScreen = (props: any) => {
  const { getNotify, isPending: notifyLoading } = useNotifyApi();
  const { open } = props;
  const authSlice = useSelector(getAuthDetails);
  const navigate = useNavigate();
  const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const [params, setParams] = useState<any>(orbitParamValue(searchParams));
  const clearNotification=(id:any=null)=>{
    let payload:any ={}
    if(id){
      payload.noti_id=id
    }else{

      payload.usr_id =authSlice.user_details.usr_id
    }

    deleteNotification(payload)
  }
  const { mutate: deleteNotification } = useMutation({
    mutationFn: orbitService.deleteNotification,
    onSuccess: (data) => {
      getNotify(authSlice.user_details.usr_id)
    },
  });
  const { mutate: seenNotification } = useMutation({
    mutationFn: orbitService.seenNotification,
    onSuccess: (data) => {
      getNotify(authSlice.user_details.usr_id)
    },
  });
  const onClickNotifyCard =(data:any)=>{
    const payload ={
      noti_id:data.id,
      seen:1 
    }
    seenNotification(payload)
    navigate({
      pathname: `/view/planet/${data.notice.orb_id}/${data.notice.pro_id}`,
      search: `?fr=${params.fr}`,
    });
     dispatch(setNotification(false))
  }

  return (
    <>
      <NotificationTab open={open} clearNotification={clearNotification} onClickNotifyCard={onClickNotifyCard}  />
    </>
  );
};

export default NotificationScreen;
